import { Link } from 'react-router-dom'

export function Logo({ compact = false }: { compact?: boolean }) {
  return <Link to="/" className="logo" aria-label="FindBack home"><span className="logo-mark" aria-hidden="true"><span /></span>{!compact && <span>Find<span>Back</span></span>}</Link>
}

